/**
 * Parameters that are sent to a call to the `/authorize` endpoint.
 */

/**
 * Options for controlling the SDK's behaviour when calling the `/authorize` endpoint.
 */

/**
 * Parameters for sending to the Auth0 logout endpoint.
 */

/**
 * Options for configuring the SDK's clear session behaviour.
 */

/**
 * Options for building a URL for `/authorize`
 */

/**
 * Options for the logout endpoint
 */

/**
 * Options for the `/oauth/token` endpoint to exchange a code for an access token
 */

/**
 * Options for obtaining user tokens from an external provider's token
 */

/**
 * Options for authenticating using the username & password grant.
 */

/**
 * Refresh token parameters
 */

/**
 * Options for requesting passwordless login using email
 */

/**
 * Options for requesting passwordless login using SMS
 */

/**
 * The options for completing the passwordless login with email request
 */

/**
 * The options for completing the passwordless login with SMS request
 */

/**
 * Options for logging in using an OTP code
 */

/**
 * Options for logging in using an OOB code
 */

/**
 * Options for logging in using a recovery code
 */

/**
 * Options for multifactor challenge.
 */

/**
 * Options for the revoke refresh token endpoint.
 */

/**
 * Options for accessing the `/userinfo` endpoint.
 */

/**
 * Options for resetting a user's password.
 */

/**
 * Options for creating a new user.
 */

/**
 * Presentation styles for when using SFSafariViewController on iOS.
 * For the full description of what each option does, please see {@link https://developer.apple.com/documentation/uikit/uimodalpresentationstyle} for more details
 */
export let SafariViewControllerPresentationStyle = /*#__PURE__*/function (SafariViewControllerPresentationStyle) {
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["automatic"] = -2] = "automatic";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["none"] = -1] = "none";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["fullScreen"] = 0] = "fullScreen";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["pageSheet"] = 1] = "pageSheet";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["formSheet"] = 2] = "formSheet";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["currentContext"] = 3] = "currentContext";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["custom"] = 4] = "custom";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["overFullScreen"] = 5] = "overFullScreen";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["overCurrentContext"] = 6] = "overCurrentContext";
  SafariViewControllerPresentationStyle[SafariViewControllerPresentationStyle["popover"] = 7] = "popover";
  return SafariViewControllerPresentationStyle;
}({});
//# sourceMappingURL=types.js.map